"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _actions = require("egov-ui-framework/ui-redux/screen-configuration/actions");

var _get = require("lodash/get");

var _get2 = _interopRequireDefault(_get);

var _actions2 = require("egov-ui-kit/redux/form/actions");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var formConfig = {
  name: "propertyDetails",
  fields: {
    natureOfProperty: {
      id: "natureOfProperty",
      jsonPath: "Properties[0].propertyDetails.natureOfProperty",
      type: "singleValueList",
      floatingLabelText: "Nature of Property",
      errorStyle: { position: "absolute", bottom: -8, zIndex: 5 },
      errorMessage: "PT_ADDRESS_ERROR_MESSAGE",

      dropDownData: [{ value: "", label: "Select" }, {
        value: "Residential-self",
        label: "Residential-self"
      }, {
        value: "Residential-Tenanted",
        label: "Residential-Tenanted"
      }, {
        value: "Non Residential-self",
        label: "Non Residential-self"
      }, {
        value: "Non Residential-Tenanted",
        label: "Non Residential-Tenanted"
      }],
      numcols: 6,
      gridDefination: {
        xs: 12,
        sm: 6
      },
      updateDependentFields: function updateDependentFields(_ref) {
        var formKey = _ref.formKey,
            field = _ref.field,
            dispatch = _ref.dispatch,
            state = _ref.state;

        if (field.value) dispatch((0, _actions.prepareFinalObject)("Properties[0].propertyDetails.natureOfProperty", field.value));
      }
    },

    typeOfUse: {
      id: "typeOfUse",
      jsonPath: "Properties[0].propertyDetails.typeOfUse",
      type: "textfield",
      floatingLabelText: "Type of Use",
      // hintText: "Type of Use",
      errorStyle: { position: "absolute", bottom: -8, zIndex: 5 },
      errorMessage: "PT_ADDRESS_ERROR_MESSAGE",
      numcols: 6,
      gridDefination: {
        xs: 12,
        sm: 6
      },
      updateDependentFields: function updateDependentFields(_ref2) {
        var formKey = _ref2.formKey,
            field = _ref2.field,
            dispatch = _ref2.dispatch,
            state = _ref2.state;

        if (field.value) dispatch((0, _actions.prepareFinalObject)("Properties[0].propertyDetails.typeOfUse", field.value));
      }
    },

    blockNo: {
      id: "blockNo",
      jsonPath: "Properties[0].propertyDetails.blockNo",
      type: "textfield",
      floatingLabelText: "Block No",
      // hintText: "Block No",
      errorStyle: { position: "absolute", bottom: -8, zIndex: 5 },
      errorMessage: "PT_ADDRESS_ERROR_MESSAGE",
      updateDependentFields: function updateDependentFields(_ref3) {
        var formKey = _ref3.formKey,
            field = _ref3.field,
            dispatch = _ref3.dispatch,
            state = _ref3.state;

        if (field.value) dispatch((0, _actions.prepareFinalObject)("Properties[0].propertyDetails.blockNo", field.value));
      }
    },

    floorNo: {
      id: "floorNo",
      jsonPath: "Properties[0].propertyDetails.floorNo",
      type: "textfield",
      floatingLabelText: "Floor No",
      // hintText: "Floor No",
      errorStyle: { position: "absolute", bottom: -8, zIndex: 5 },
      errorMessage: "PT_ADDRESS_ERROR_MESSAGE",
      updateDependentFields: function updateDependentFields(_ref4) {
        var formKey = _ref4.formKey,
            field = _ref4.field,
            dispatch = _ref4.dispatch,
            state = _ref4.state;

        if (field.value) dispatch((0, _actions.prepareFinalObject)("Properties[0].propertyDetails.floorNo", field.value));
      }
    },

    flatNo: {
      id: "flatNo",
      jsonPath: "Properties[0].propertyDetails.flatNo",
      type: "textfield",
      floatingLabelText: "Flat No",
      // hintText: "Flat No",
      errorStyle: { position: "absolute", bottom: -8, zIndex: 5 },
      errorMessage: "PT_ADDRESS_ERROR_MESSAGE",
      updateDependentFields: function updateDependentFields(_ref5) {
        var formKey = _ref5.formKey,
            field = _ref5.field,
            dispatch = _ref5.dispatch,
            state = _ref5.state;

        if (field.value) dispatch((0, _actions.prepareFinalObject)("Properties[0].propertyDetails.flatNo", field.value));
      }
    },
    natureOfUse: {
      id: "natureOfUse",
      jsonPath: "Properties[0].propertyDetails.natureOfUse",
      type: "singleValueList",
      floatingLabelText: "Nature of Use",

      dropDownData: [{ value: "", label: "Select" }, {
        value: "Part Non Residential",
        label: "Part Non Residential"
      }, {
        value: "Part Residential",
        label: "Part Residential"
      }, {
        value: "Residential (Full)",
        label: "Residential (Full)"
      }, {
        value: "Non Residential (Full)",
        label: "Non Residential (Full)"
      }],
      errorStyle: { position: "absolute", bottom: -8, zIndex: 5 },
      errorMessage: "PT_ADDRESS_ERROR_MESSAGE",
      numcols: 6,
      gridDefination: {
        xs: 12,
        sm: 6
      },
      updateDependentFields: function updateDependentFields(_ref6) {
        var formKey = _ref6.formKey,
            field = _ref6.field,
            dispatch = _ref6.dispatch,
            state = _ref6.state;

        if (field.value) dispatch((0, _actions.prepareFinalObject)("Properties[0].propertyDetails.natureOfUse", field.value));
      }
    },
    occupierStatus: {
      id: "occupierStatus",
      jsonPath: "Properties[0].propertyDetails.occupierStatus",
      type: "singleValueList",
      floatingLabelText: "Occupier Status",
      hintText: "Occupier Status",
      numcols: 6,

      dropDownData: [{ value: "", label: "Select" }, {
        value: "Residential-self",
        label: "Residential-self"
      }, {
        value: "Residential-Tenanted",
        label: "Residential-Tenanted"
      }, {
        value: "Non Residential-self",
        label: "Non Residential-self"
      }, {
        value: "Non Residential-Tenanted",
        label: "Non Residential-Tenanted"
      }],
      gridDefination: {
        xs: 12,
        sm: 6
      },
      errorStyle: { position: "absolute", bottom: -8, zIndex: 5 },
      errorMessage: "PT_ADDRESS_ERROR_MESSAGE",
      updateDependentFields: function updateDependentFields(_ref7) {
        var formKey = _ref7.formKey,
            field = _ref7.field,
            dispatch = _ref7.dispatch,
            state = _ref7.state;

        if (field.value) dispatch((0, _actions.prepareFinalObject)("Properties[0].propertyDetails.occupierStatus", field.value));
      }
    },

    occupierName: {
      id: "occupierName",
      jsonPath: "Properties[0].propertyDetails.occupierName",
      type: "textfield",
      floatingLabelText: "Occupier Name",
      localePrefix: true,
      labelsFromLocalisation: false,
      // hintText: "Occupier Name",
      numcols: 6,
      gridDefination: {
        xs: 12,
        sm: 6
      },
      formName: "propertyDetails",
      updateDependentFields: function updateDependentFields(_ref8) {
        var formKey = _ref8.formKey,
            field = _ref8.field,
            dispatch = _ref8.dispatch,
            state = _ref8.state;

        if (field.value) dispatch((0, _actions.prepareFinalObject)("Properties[0].propertyDetails.occupierName", field.value));
      }
    },
    rentPM: {
      id: "rentPM",
      jsonPath: "Properties[0].propertyDetails.rentPM",
      type: "textfield",
      floatingLabelText: "Rent/RR P.M.",
      // hintText: "Rent/RR P.M.",
      errorStyle: { position: "absolute", bottom: -8, zIndex: 5 },
      errorMessage: "PT_ADDRESS_ERROR_MESSAGE",
      updateDependentFields: function updateDependentFields(_ref9) {
        var formKey = _ref9.formKey,
            field = _ref9.field,
            dispatch = _ref9.dispatch,
            state = _ref9.state;

        if (field.value) dispatch((0, _actions.prepareFinalObject)("Properties[0].propertyDetails.rentPM", field.value));
      }
    }
  },
  beforeInitForm: function beforeInitForm(action, store) {
    return action;
  },
  afterInitForm: function afterInitForm(action, store, dispatch) {
    function getParameterByName(name) {
      var url = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window.location.href;

      name = name.replace(/[\[\]]/g, "\\$&");
      var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
          results = regex.exec(url);
      if (!results) return null;
      if (!results[2]) return "";
      return decodeURIComponent(results[2].replace(/\+/g, " "));
    }

    var urlParams = getParameterByName("isInspection");
    if (urlParams == "yes") {
      var state = store.getState();
      var data = (0, _get2.default)(state.screenConfiguration.preparedFinalObject, "Properties");

      if (data && data.length > 0) {
        var propertyDetails = data[0].propertyDetails;

        if (propertyDetails && Object.keys(propertyDetails).length > 0) {
          dispatch((0, _actions2.setFieldProperty)("propertyDetails", "natureOfProperty", "value", propertyDetails.natureOfProperty.toString()));
          dispatch((0, _actions2.setFieldProperty)("propertyDetails", "typeOfUse", "value", propertyDetails.typeOfUse.toString()));
          dispatch((0, _actions2.setFieldProperty)("propertyDetails", "blockNo", "value", propertyDetails.buildingName ? propertyDetails.buildingName.toString() : ""));
          dispatch((0, _actions2.setFieldProperty)("propertyDetails", "floorNo", "value", propertyDetails.floorNo ? propertyDetails.floorNo.toString() : ""));
          dispatch((0, _actions2.setFieldProperty)("propertyDetails", "flatNo", "value", propertyDetails.flatNo ? propertyDetails.flatNo.toString() : ""));
          dispatch((0, _actions2.setFieldProperty)("propertyDetails", "natureOfUse", "value", propertyDetails.natureOfUse ? propertyDetails.natureOfUse.toString() : ""));
          dispatch((0, _actions2.setFieldProperty)("propertyDetails", "occupierStatus", "value", propertyDetails.occupierStatus ? propertyDetails.occupierStatus.toString() : ""));
          dispatch((0, _actions2.setFieldProperty)("propertyDetails", "occupierName", "value", propertyDetails.occupierName ? propertyDetails.occupierName.toString() : ""));
          dispatch((0, _actions2.setFieldProperty)("propertyDetails", "rentPM", "value", propertyDetails.pRent ? propertyDetails.pRent.toString() : ""));

          dispatch((0, _actions.prepareFinalObject)("Properties[0].propertyDetails.natureOfProperty", propertyDetails.natureOfProperty ? propertyDetails.natureOfProperty.toString() : ""));
          dispatch((0, _actions.prepareFinalObject)("Properties[0].propertyDetails.typeOfUse", propertyDetails.typeOfUse ? propertyDetails.typeOfUse.toString() : ""));
          dispatch((0, _actions.prepareFinalObject)("Properties[0].propertyDetails.buildingName", propertyDetails.buildingName ? propertyDetails.buildingName.toString() : ""));
          dispatch((0, _actions.prepareFinalObject)("Properties[0].propertyDetails.floorNo", propertyDetails.floorNo ? propertyDetails.floorNo.toString() : ""));
          dispatch((0, _actions.prepareFinalObject)("Properties[0].propertyDetails.flatNo", propertyDetails.flatNo ? propertyDetails.flatNo.toString() : ""));
          dispatch((0, _actions.prepareFinalObject)("Properties[0].propertyDetails.natureOfUse", propertyDetails.natureOfUse ? propertyDetails.natureOfUse.toString() : ""));
          dispatch((0, _actions.prepareFinalObject)("Properties[0].propertyDetails.occupierStatus", propertyDetails.occupierStatus ? propertyDetails.occupierStatus.toString() : ""));
          dispatch((0, _actions.prepareFinalObject)("Properties[0].propertyDetails.occupierName", propertyDetails.occupierName ? propertyDetails.occupierName.toString() : ""));
          dispatch((0, _actions.prepareFinalObject)("Properties[0].propertyDetails.pRent", propertyDetails.pRent ? propertyDetails.pRent.toString() : ""));
        }
      }
    }
    return action;
  },
  action: "",
  redirectionRoute: "",
  saveUrl: "",
  isFormValid: false
};

exports.default = formConfig;


//////////////////
// WEBPACK FOOTER
// ../lib/egov-ui-kit/config/forms/specs/PropertyTaxPayForInspection/propertyDetails.js
// module id = 1890
// module chunks = 1137